import cx from "classnames";
import { Icon } from "common/LegacyIcon";
import { Popover } from "common/Popover";
import { RichUtils } from "draft-js";
import { convertBlockToHeader, insertAtomicBlock } from "lib/blockUtils";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./SideToolbar.scss";
const { toggleBlockType } = RichUtils;

export const ADD_BLOCK = "ADD_BLOCK";
export const CHANGE_STYLE = "CHANGE_STYLE";

const preventDefault = (e) => e.preventDefault();
const stopPropagation = (e) => e.stopPropagation();

class Button extends React.Component {
  render() {
    const { i, onClick, onBlur, children, focus } = this.props;
    const setFocus = (elem) => {
      if (!elem) return;
      if (focus) {
        elem.focus();
      } else {
        elem.blur();
      }
    };
    return (
      <a
        className={styles.linkButton}
        tabIndex={0}
        onMouseDown={preventDefault}
        onClick={onClick}
        onBlur={onBlur}
        style={{ position: "relative" }}
        ref={setFocus}
      >
        <Icon i={i} size={22} />
        {children}
      </a>
    );
  }
}

const ChangeStylePopover = ({ changeStyle }) => (
  <Popover
    onMouseDown={preventDefault}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
    }}
  >
    <li onClick={() => changeStyle("unstyled")}>
      <T id="SideToolbar.paragraph" defaultMessage="paragraph" />
    </li>
    <li onClick={() => changeStyle("header-two")}>
      <T id="SideToolbar.heading" defaultMessage="heading" />
    </li>
    <li onClick={() => changeStyle("unordered-list-item")}>
      <T id="SideToolbar.bullets" defaultMessage="bullets" />
    </li>
    <li onClick={() => changeStyle("ordered-list-item")}>
      <T id="SideToolbar.list" defaultMessage="list" />
    </li>
  </Popover>
);

export class SideToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popover: false,
      cachedOffset: false,
    };
  }

  toggle = (popover) => {
    if (this.state.popover === popover) {
      this.setState({ popover: false, cachedOffset: false });
      this.props.restoreFocus();
    } else {
      // because activating a popover will steal focus from the editor and reset
      // the selection offset, we have to cache the offset here and then clear
      // it when the popover interaction is complete
      this.setState({
        popover,
        cachedOffset: this.state.cachedOffset || this.props.offset,
      });
    }
  };

  collapse = (popover) => {
    if (this.state.popover === popover) {
      this.setState({ popover: false, cachedOffset: false });
    }
  };

  changeStyle = (newStyle) => {
    const { editorState } = this.props;
    if (newStyle === "header-two") {
      // special case for converting to headings where we nuke the inline styles
      const newEditorState = convertBlockToHeader(editorState);
      this.props.onChange(newEditorState, this.props.restoreFocus);
    } else {
      // otherwise just let RichUtils handle it
      const newEditorState = toggleBlockType(editorState, newStyle);
      this.props.onChange(newEditorState, this.props.restoreFocus);
    }
  };

  insertBlock = (type) => {
    const editorState = insertAtomicBlock(this.props.editorState, { type });
    this.props.onChange(editorState, this.props.restoreFocus);
  };

  shouldRender() {
    return this.state.cachedOffset !== false || this.props.visible;
  }

  render() {
    const { offset, editorState, removeBlock } = this.props;
    const { popover, cachedOffset } = this.state;
    const currentBlockType = RichUtils.getCurrentBlockType(editorState);
    const currentBlockKey = editorState.getSelection().getStartKey();
    const currentBlock = editorState.getCurrentContent().getBlockMap().get(currentBlockKey);
    const displayTop =
      currentBlock &&
      currentBlock.getType() === "atomic" &&
      currentBlock.getData() &&
      currentBlock.getData().get("size") === "bigBlock";
    const textBlock = currentBlockType !== "atomic";

    const top = cachedOffset !== false ? cachedOffset : offset;
    const style = {
      top: displayTop ? top - 25 : top + 5,
    };

    if (!this.shouldRender()) {
      return null;
    }
    // onMouseDown preventDefault is needed to stop editor from losing focus
    return (
      <div className={cx(styles.SideToolbar, textBlock && styles.isTextBlock)} style={style} onClick={stopPropagation}>
        <Button i="circlePlus" onClick={() => this.insertBlock("metablock")} />
        {currentBlockType === "atomic" && <Button i="circleXFilled" onClick={() => removeBlock(currentBlockKey)} />}
        {currentBlockType !== "atomic" && (
          <Button
            i="menu"
            onClick={() => this.toggle(CHANGE_STYLE)}
            onBlur={() => this.collapse(CHANGE_STYLE)}
            focus={popover === CHANGE_STYLE}
          >
            {popover === CHANGE_STYLE && <ChangeStylePopover changeStyle={this.changeStyle.bind(this)} />}
          </Button>
        )}
      </div>
    );
  }
}
